<template lang="html">
    <entity-page id="page__stock__worker" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <z-input-autocomplete
            v-model="user" v-bind:items="users"
            v-bind:callback="suggestUsers" v-bind:show-on-focus="true"
            data-vv-name="user" v-bind:data-vv-as="' '"
            name="user"   id="id"     display-property="login"
            property="id" return="id" label="ФИО, логин или email"
            default="" v-bind:required="true" v-validate="'required'"
        ></z-input-autocomplete>
        <p> Внимание! Если пользователь уже прикреплён к складу, он не будет отображаться в списке, в поле выше. </p>
    </entity-page>
</template>
<script>
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: { EntityPage, ZIconButton, ZInputAutocomplete },
        data() {
            return {
                user: null,
                users: []
            }
        },
        computed: {
            /**
			 * Флаг загрузки текущего компонента
			 */
            progress() {
                return this.progressObj['load-stockworker-card'];
            },
            /**
			 * Объект с флагами загрузки
			 */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        created() {
            this.$store.commit('openRightPanel');
            this.getItemsUsers();
        },
        methods: {
            /**
             * Сохранение
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-stockworker-card');
                    this.$store.dispatch('stock/attachUser', { userId: this.user, stockId: this.$route.params.stock_id })
                        .then(() => this.$root.$emit('refresh-table', 'stock-workers'))
                        .finally(() => this.$store.commit('hideProgressBar', 'load-stockworker-card'));
                })
            },
            /**
             * Возвращает пользователя на предыдущую страницу
             */
            back() {
                this.$router.push({name: 'StockWorkers', query: this.$route.query});
            },
            /**
             * Получение пользователей
             */
            getItemsUsers() {
                let data = {
                    page:       1,
                    order_by:   'id',
                    order_type: 'asc',
                    count:      50,
                    filter: {
                        model: [],
                        relation: [
                            ['groups', 'code', '=', ['forwarders', 'agent', 'storekeepers']],
                            ['stock', 'id', '!=!', null]
                        ],
                        symbol: 'and',
                        condition: 'and'
                    }
                };
                return this.$store.dispatch('users/getUsers', data).then(r => {
                    let users = r.map(item => {
                        let groups = [];
                        if (item.groups && item.groups.length) item.groups.map(item => groups.push(item.name));
                        groups = groups.join(', ');
                        return {
                            id: item.id,
                            login: (item.fio ? item.fio : '') + (item.login ? ' (' +  item.login + ')' : '') + (groups.length ? ': ' + groups : '')
                        };
                    });
                    this.users = Object.assign([], users);
                    return users;
                });
            },
            /**
             * Предложение пользователей
             */
            suggestUsers(search) {
                let data = {
                    page:       1,
                    order_by:   'id',
                    order_type: 'asc',
                    count:      50,
                    filter:     {
                        model: [['login', '%', search], 'or', ['email', '%', search], 'or', ['fio', '%', search]], 
                        relation: [
                            ['groups', 'code', '=', ['forwarders', 'agent', 'storekeepers']],
                            ['stock', 'id', '!=!', null]
                        ],
                        symbol: 'and',
                        condition: 'and'
                    }
                };
                return this.$store.dispatch('users/getUsers', data).then(r => {
                    let users = r.map(item => {
                        let groups = [];
                        if (item.groups && item.groups.length) item.groups.map(item => groups.push(item.name));
                        groups = groups.join(', ');
                        return {
                            id: item.id,
                            login: (item.fio ? item.fio : '') + (item.login ? ' (' +  item.login + ')' : '') + (groups.length ? ': ' + groups : '')
                        };
                    });

                    return users;
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// StockWorker.vue?f17bb094